const BASE_MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export function monthLabel(offset, startYear = 2026, startMonth = 5) {
  const idx = (startMonth + offset) % 12;
  const year = startYear + Math.floor((startMonth + offset) / 12);
  return `${BASE_MONTHS[idx]} ${String(year).slice(2)}`;
}

/**
 * Results table column label.
 * - calendarAligned: column i = plan start + i (matches marketing plan row i spend month).
 * - legacy: column 0 is one month before plan start (historical padded-plan layout).
 */
export function resultMonthLabel(
  columnIndex,
  startYear = 2026,
  startMonth = 5,
  calendarAligned = false
) {
  const offset = calendarAligned ? columnIndex : columnIndex - 1;
  return monthLabel(offset, startYear, startMonth);
}

/**
 * Month label for marketing plan row i.
 * - calendarIndexedRows (AI upload): row i = planStart + i months (spend month).
 * - legacy (DEFAULTS / padded plan): row i>=1 spend posts in results column i
 *   (monthLabel(i-1)); row 0 is plan start.
 */
export function marketingPlanMonthLabel(
  planRowIndex,
  startYear = 2026,
  startMonth = 5,
  calendarIndexedRows = false
) {
  if (calendarIndexedRows) {
    return monthLabel(planRowIndex, startYear, startMonth);
  }
  if (planRowIndex <= 0) {
    return monthLabel(0, startYear, startMonth);
  }
  return monthLabel(planRowIndex - 1, startYear, startMonth);
}

export function marketingPlanMonthLabels(
  count = 13,
  startYear = 2026,
  startMonth = 5,
  calendarIndexedRows = false
) {
  return Array.from({ length: count }, (_, i) =>
    marketingPlanMonthLabel(i, startYear, startMonth, calendarIndexedRows)
  );
}
